import { AuthenticationJourney } from '@models/api-customers.models';
import { Observable } from 'rxjs';

/**
 * access_denied	User cancelled the login
 * server_error	Something went wrong, please try again
 * login_required	User must log in with interaction
 * invalid_app_callback_uri	The app callback URI is not on a valid format
 * app_callback_uri_not_registered	The app callback URI is not registered as a redirect URI
 * outdated_app_version	The user's Vipps or MobilePay app version is too old and needs to be updated
 * wrong_challenge	The user selected the wrong challenge
 * unknown_reject_reason
 */
export type VippsErrorCode =
    | 'access_denied'
    | 'server_error'
    | 'login_required'
    | 'invalid_app_callback_uri'
    | 'outdated_app_version'
    | 'wrong_challenge'
    | 'unknown_reject_reason';

/**
 * custom_email_not_verified	The user's email on Vipps is not verified, and it's important to have it verified otherwise we will not login the user
 * custom_generic_error	An error occurred during the login process, but we can't identify the reason
 */
export type VippsCustomErrorCode = 'custom_email_not_verified' | 'custom_generic_error' | 'expired_token';

export type MSALErrorCode = 'access_denied';

export interface B2cAdConfiguration {
    loginRedirectPath?: string;
    loginClientId?: string;
    loginAuthorityProvider?: string;
    loginSignUpSignInFlow?: string;
    loginSignUpFlow?: string;
    loginResetPasswordFlow?: string;
}

export type Journey = AuthenticationJourney | 'Signout';

export type AuthMode = 'AzureB2C' | 'Vipps';
export type LoginState = {
    authMode?: AuthMode;
    loggedIn: boolean;
    username?: string;
    token?: string;
    expiresAt?: string;
    error?: VippsErrorCode | VippsCustomErrorCode | MSALErrorCode;
};

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface IAuthenticationService {
    loginState$: Observable<LoginState>;

    login(source: AuthMode, email?: string, silentOnly?: boolean): void;

    logout(source: AuthMode, redirectUriExtension: string): Promise<void>;

    initializeAuthService(): void;

    trackSignIn(): void;
}

export const authTokensKey = 'auth-tokens';
export const authModeKey = 'auth-mode';
export const authExpiresAtKey = 'auth-expires-at';
